import { z } from "zod";

export type Coordinates = {
  latitude: number;
  longitude: number;
};

// Todo; this should be renamed to Coordinates. There is no "user" in this type.
export type UserCoordinate = {
  longitude: number;
  latitude: number;
};

export const UserCoordinateSchema = z.object({
  latitude: z.number(),
  longitude: z.number(),
});
